import { Map, Set } from 'immutable';

import { CHANNEL_STATUSES, PUBLISH_ACTION, STATUS, STATUS_NAME, STATUS_TYPE, VELA_STATUSES } from '../../constants/listings';
import { EBAY, ETSY, FAIRE, SHOPIFY } from '../../constants/channels';
import { EMPTY, VELA } from '../../constants';
import { FEATURE } from '../../constants/features';

export function getPublishActions({ channel, status }) {
  switch (channel) {
    case EBAY: {
      switch (status) {
        case STATUS[VELA].COPIED:
        case STATUS[VELA].STAGING:
        case STATUS[VELA].IMPORTED:
        case STATUS[VELA].TEMPLATE:
        case STATUS[VELA].UNPUBLISHED: {
          return [PUBLISH_ACTION.PUBLISH];
        }

        default: {
          return [];
        }
      }
    }

    case ETSY: {
      switch (status) {
        case STATUS[ETSY].DRAFT:
        case STATUS[ETSY].INACTIVE: {
          return [PUBLISH_ACTION.PUBLISH];
        }

        case STATUS[VELA].COPIED:
        case STATUS[VELA].STAGING:
        case STATUS[VELA].IMPORTED:
        case STATUS[VELA].TEMPLATE:
        case STATUS[VELA].UNPUBLISHED: {
          return [PUBLISH_ACTION.PUBLISH, PUBLISH_ACTION.SAVE_AS_DRAFT];
        }

        default: {
          return [];
        }
      }
    }

    case FAIRE: {
      switch (status) {
        case STATUS[FAIRE].DRAFT:
        case STATUS[FAIRE].UNPUBLISHED: {
          return [PUBLISH_ACTION.PUBLISH];
        }

        case STATUS[VELA].COPIED:
        case STATUS[VELA].STAGING:
        case STATUS[VELA].IMPORTED:
        case STATUS[VELA].TEMPLATE:
        case STATUS[VELA].UNPUBLISHED: {
          return [PUBLISH_ACTION.PUBLISH, PUBLISH_ACTION.SAVE_AS_DRAFT];
        }

        default: {
          return [];
        }
      }
    }

    case SHOPIFY: {
      switch (status) {
        case STATUS[SHOPIFY].DRAFT:
        case STATUS[SHOPIFY].ARCHIVED: {
          return [PUBLISH_ACTION.PUBLISH];
        }

        case STATUS[VELA].COPIED:
        case STATUS[VELA].STAGING:
        case STATUS[VELA].IMPORTED:
        case STATUS[VELA].TEMPLATE:
        case STATUS[VELA].UNPUBLISHED: {
          return [PUBLISH_ACTION.PUBLISH, PUBLISH_ACTION.SAVE_AS_DRAFT];
        }

        default: {
          return [];
        }
      }
    }

    default: {
      return [];
    }
  }
}

export function getPublishStatus({ action, channel, isVelaOnlyShop }) {
  if (isVelaOnlyShop) {
    return STATUS[VELA].STAGING;
  }

  switch (channel) {
    case EBAY: {
      switch (action) {
        case PUBLISH_ACTION.PUBLISH: {
          return STATUS[EBAY].ACTIVE;
        }

        case PUBLISH_ACTION.SCHEDULE:
        case PUBLISH_ACTION.RESCHEDULE: {
          return STATUS[VELA].SCHEDULED;
        }

        default: {
          return undefined;
        }
      }
    }

    case ETSY: {
      switch (action) {
        case PUBLISH_ACTION.PUBLISH: {
          return STATUS[ETSY].ACTIVE;
        }

        case PUBLISH_ACTION.SAVE_AS_DRAFT: {
          return STATUS[ETSY].DRAFT;
        }

        case PUBLISH_ACTION.SCHEDULE:
        case PUBLISH_ACTION.RESCHEDULE: {
          return STATUS[VELA].SCHEDULED;
        }

        default: {
          return undefined;
        }
      }
    }

    case FAIRE: {
      switch (action) {
        case PUBLISH_ACTION.PUBLISH: {
          return STATUS[FAIRE].PUBLISHED;
        }

        case PUBLISH_ACTION.SAVE_AS_DRAFT: {
          return STATUS[FAIRE].DRAFT;
        }

        case PUBLISH_ACTION.SCHEDULE:
        case PUBLISH_ACTION.RESCHEDULE: {
          return STATUS[VELA].SCHEDULED;
        }

        default: {
          return undefined;
        }
      }
    }

    case SHOPIFY: {
      switch (action) {
        case PUBLISH_ACTION.PUBLISH: {
          return STATUS[SHOPIFY].ACTIVE;
        }

        case PUBLISH_ACTION.SAVE_AS_DRAFT: {
          return STATUS[SHOPIFY].DRAFT;
        }

        case PUBLISH_ACTION.SCHEDULE:
        case PUBLISH_ACTION.RESCHEDULE: {
          return STATUS[VELA].SCHEDULED;
        }

        default: {
          return undefined;
        }
      }
    }

    default: {
      return undefined;
    }
  }
}

export function getChannelStatus({ channel, status, isVelaOnlyShop }) {

  switch (status) {
    case STATUS[VELA].COPIED: {
      return STATUS[VELA].COPIED;
    }

    case STATUS[VELA].STAGING: {
      return STATUS[VELA].STAGING;
    }

    case STATUS[VELA].IMPORTED:
    case STATUS[VELA].UNPUBLISHED: {
      return STATUS[VELA].UNPUBLISHED;
    }

    default: {
      if (isVelaOnlyShop) {
        return STATUS[VELA].COPIED;
      }
      switch (channel) {
        case EBAY: {
          return STATUS[EBAY].ACTIVE;
        }

        case ETSY: {
          switch (status) {
            case STATUS[EBAY].ACTIVE:
            case STATUS[ETSY].ACTIVE:
            case STATUS[FAIRE].PUBLISHED:
            case STATUS[SHOPIFY].ACTIVE: {
              return STATUS[ETSY].ACTIVE;
            }

            case STATUS[ETSY].DRAFT:
            case STATUS[FAIRE].DRAFT:
            case STATUS[SHOPIFY].DRAFT: {
              return STATUS[ETSY].DRAFT;
            }

            case STATUS[ETSY].INACTIVE:
            case STATUS[FAIRE].UNPUBLISHED:
            case STATUS[SHOPIFY].ARCHIVED: {
              return STATUS[ETSY].INACTIVE;
            }

            default: {
              return STATUS[ETSY].ACTIVE;
            }
          }
        }

        case SHOPIFY: {
          switch (status) {
            case STATUS[EBAY].ACTIVE:
            case STATUS[ETSY].ACTIVE:
            case STATUS[FAIRE].PUBLISHED:
            case STATUS[SHOPIFY].ACTIVE: {
              return STATUS[SHOPIFY].ACTIVE;
            }

            case STATUS[ETSY].DRAFT:
            case STATUS[FAIRE].DRAFT:
            case STATUS[SHOPIFY].DRAFT: {
              return STATUS[SHOPIFY].DRAFT;
            }

            case STATUS[ETSY].INACTIVE:
            case STATUS[FAIRE].UNPUBLISHED:
            case STATUS[SHOPIFY].ARCHIVED: {
              return STATUS[SHOPIFY].ARCHIVED;
            }

            default: {
              return STATUS[SHOPIFY].ACTIVE;
            }
          }
        }

        case FAIRE: {
          switch (status) {
            case STATUS[EBAY].ACTIVE:
            case STATUS[ETSY].ACTIVE:
            case STATUS[FAIRE].PUBLISHED:
            case STATUS[SHOPIFY].ACTIVE: {
              return STATUS[FAIRE].PUBLISHED;
            }

            case STATUS[ETSY].DRAFT:
            case STATUS[FAIRE].DRAFT:
            case STATUS[SHOPIFY].DRAFT: {
              return STATUS[FAIRE].DRAFT;
            }

            case STATUS[ETSY].INACTIVE:
            case STATUS[FAIRE].UNPUBLISHED:
            case STATUS[SHOPIFY].ARCHIVED: {
              return STATUS[FAIRE].UNPUBLISHED;
            }

            default: {
              return STATUS[FAIRE].PUBLISHED;
            }
          }
        }

        default: {
          return undefined;
        }
      }
    }
  }
}

export function getStatusName({ channel, status }) {
  switch (status) {
    case STATUS[VELA].COPIED: {
      return STATUS_NAME.COPY;
    }

    case STATUS[VELA].IMPORTED:
    case STATUS[VELA].UNPUBLISHED: {
      return STATUS_NAME.IMPORTED;
    }

    case STATUS[VELA].STAGING: {
      return STATUS_NAME.STAGING;
    }

    default: {
      switch (channel) {
        case EBAY: {
          return STATUS_NAME.ACTIVE;
        }

        case ETSY: {
          switch (status) {
            case STATUS[EBAY].ACTIVE: {
              return STATUS_NAME.ACTIVE;
            }

            case STATUS[ETSY].DRAFT: {
              return STATUS_NAME.DRAFT;
            }

            case STATUS[ETSY].INACTIVE: {
              return STATUS_NAME.INACTIVE;
            }

            default: {
              return undefined;
            }
          }
        }

        case FAIRE: {
          switch (status) {
            case STATUS[FAIRE].PUBLISHED: {
              return STATUS_NAME.PUBLISHED;
            }

            case STATUS[FAIRE].DRAFT: {
              return STATUS_NAME.DRAFT;
            }

            case STATUS[FAIRE].UNPUBLISHED: {
              return STATUS_NAME.UNPUBLISHED;
            }

            default: {
              return undefined;
            }
          }
        }

        case SHOPIFY: {
          switch (status) {
            case STATUS[SHOPIFY].ACTIVE: {
              return STATUS_NAME.ACTIVE;
            }

            case STATUS[SHOPIFY].DRAFT: {
              return STATUS_NAME.DRAFT;
            }

            case STATUS[SHOPIFY].ARCHIVED: {
              return STATUS_NAME.ARCHIVED;
            }

            default: {
              return undefined;
            }
          }
        }

        default: {
          return undefined;
        }
      }
    }
  }
}

export function getDefaultStatuses({ channel, status, statuses = EMPTY.MAP, isVelaOnlyShop }) {
  return Map({
    expanded: statuses.get('expanded', Set([STATUS_TYPE.CHANNEL, STATUS_TYPE.VELA])),
    selected: (
      getChannelStatus({ channel, status, isVelaOnlyShop }) ||
      getPublishStatus({ action: PUBLISH_ACTION.PUBLISH, channel, isVelaOnlyShop })
    ),
  });
}

export function getFirstNonEmptyStatus({ channel, counts }) {
  for (const status of CHANNEL_STATUSES[channel]) {
    if (counts.get(status)) {
      return status;
    }
  }

  for (const status of VELA_STATUSES) {
    if (counts.get(status)) {
      return status;
    }
  }

  return undefined;
}

export function shapeCountsForApp({ channel, response, userFeatures }) {
  let counts = EMPTY.MAP;

  for (const status of CHANNEL_STATUSES[channel]) {
    counts = counts.set(status, response[status] || 0);
  }

  for (const status of VELA_STATUSES) {
    if (status === STATUS[VELA].STAGING && !userFeatures.get(FEATURE.STAGING_STATUS)) {
      continue;
    }

    counts = counts.set(status, response[status] || 0);
  }

  return counts;
}

export function isVelaStatus({ status }) {
  switch (status) {
    case STATUS[VELA].COPIED:
    case STATUS[VELA].STAGING:
    case STATUS[VELA].IMPORTED:
    case STATUS[VELA].TEMPLATE:
    case STATUS[VELA].UNPUBLISHED:
    case STATUS[VELA].SCHEDULED: {
      return true;
    }

    default: {
      return false;
    }
  }
}
